export const COACH_STEPHANE_PRIMARY_TEXT =
  "L’instructeur Stéphane Séguin, ceinture noire de jiu-jitsu brésilien, est affilié à HOMA BJJ par l'intermédiaire de Johnny Zemouli et David Coré. Il a découvert cet art martial sous la tutelle de Julio « Foca » Fernandez, membre de l’équipe Carlson Gracie. Stéphane a également pris part à de nombreux tournois aux États-Unis, où il a remporté plusieurs médailles.";

export const COACH_STEPHANE_SECONDARY_TEXT =
  "« Mon parcours… je pratique les arts martiaux depuis plus de 25 ans. J’ai une ceinture noire en ninjutsu; un sport qui contient du Ne-Waza (combat au sol), et j’ai aussi un bagage de boxe, de judo, de taiho-jutsu, ainsi qu’une ceinture noire en jiu jitsu brésilien. ».";

export const COACH_NICOLAS_PRIMARY_TEXT =
  "L’assistant instructeur Nicolas est présentement ceinture mauve en jiu jitsu brésilien. Il a plus de 10 ans d'expérience en lutte ayant pratiqué avec les Patriotes et par la suite avec l'équipe Nationale de lutte olympique ce qui fait de lui un élément clé de notre apprentissage!";

export const COACH_NICOLAS_SECONDARY_TEXT =
  "Il a décroché la première place au championnat canadien, recevant également une mention spéciale et le trophée de « meilleur lutteur de la compétition ». Lors d’une autre édition, il s’est classé deuxième. En outre, il a remporté plusieurs médailles d’or dans des championnats provinciaux, et ce, dans deux catégories distinctes.";

export type Coach = {
  name: string;
  img: string;
  bio1: string;
  bio2: string;
};

export const COACHES: Coach[] = [
  {
    name: "Stéphane Séguin",
    img: "https://media.istockphoto.com/id/1287995227/photo/close-up-on-hand-of-unknown-caucasian-man-holding-brazilian-jiu-jitsu-bjj-black-belt-around.jpg?s=612x612&w=0&k=20&c=u-BnqSCzPzFluyx5VnUU0R9fLMIRO6S9dIzDMmEAt3Q=",
    bio1: COACH_STEPHANE_PRIMARY_TEXT,
    bio2: COACH_STEPHANE_SECONDARY_TEXT,
  },
  {
    name: "Nicolas Borduas",
    img: "https://img.olympicchannel.com/images/image/private/t_s_pog_staticContent_hero_xl_2x/f_auto/primary/w1eo4el8wr6prjicq5n4",
    bio1: COACH_NICOLAS_PRIMARY_TEXT,
    bio2: COACH_NICOLAS_SECONDARY_TEXT,
  },
];
